<template>
  <div class="settings" :style="isMobile && currentTab ? 'height: 100% !important;' : ''">
    <SettingsMenu v-if="showSettingsMenu" />
    <div class="settings__separator"></div>
    <SettingsArea v-if="showSettingsArea" />
    <SettingsCloseButton v-if="!isMobile" />
  </div>
</template>

<script>
import SettingsMenu from "./SettingsMenu.vue";
import SettingsArea from "./SettingsArea.vue";
import SettingsCloseButton from "./SettingsCloseButton.vue";
import { SettingsStore } from "../ELYXStore";
import SettingsMethods from "./SettingsMethods";
import isMobile from "ismobilejs";

export default {
  components: {
    SettingsMenu,
    SettingsArea,
    SettingsCloseButton,
  },
  computed: {
    currentTab: () => SettingsStore.state.currentTab,
    showSettingsMenu() {
      if (this.$windowWidth >= 750 && this.currentTab) {
        /** If large view and current tab available */
        return true;
      } else if (this.$windowWidth < 750 && !this.currentTab) {
        /** If small view and no tab yet selected */
        return true;
      }
      /** Otherwise do not show */
      return false;
    },
    showSettingsArea() {
      if (this.$windowWidth >= 750 && this.currentTab) {
        /** If large view and current tab available */
        return true;
      } else if (this.$windowWidth < 750 && this.currentTab) {
        /** If small view and a tab has been selected */
        return true;
      }
      /** Otherwise do not show */
      return false;
    },
    isMobile() {
      return isMobile().phone;
    },
  },
  watch: {
    $windowWidth: {
      handler() {
        if (this.$windowWidth >= 750) {
          if (!this.currentTab) {
            SettingsMethods.setFirstTab();
          }
        }
      },
    },
  },
};
</script>

<style scoped>
.settings {
  display: flex;
  flex-wrap: wrap;
  /* width: 941px; */
  /* width: max-content; */
  width: 100%;
  justify-content: center;
  align-content: space-between;
  overflow-y: scroll;
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
  background-color: rgb(250 250 250 / 75%);
  /* background-color: rgb(255 255 255 / 80%); */
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  border-radius: 16px;
  margin: 0 auto;
  min-height: 650px;
  position: relative;
  overflow-y: hidden;
  height: 705px;
  box-sizing: border-box;
}
.settings__separator {
  border-right: 1px solid #dcdcdc;
  box-sizing: border-box;
  margin-top: -15px;
  margin-bottom: -15px;
}
@media (max-height: 865px) {
  .settings {
    height: 100vh;
    min-height: unset;
    border-radius: 0px;
  }
}
@media (max-width: 749px) {
  .settings {
    width: 100vw;
    max-width: unset;
    height: 100vh;
    min-height: unset;
    border-radius: 0px;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .settings__separator {
    display: none;
  }
}
</style>
